const TeacherOccupations = ['teacher', 'teacher_school', 'teacher_university', 'department_head', 'instructional_tech_coach'];

export default TeacherOccupations;
